import { connect } from 'react-redux';
import Surveys from '../../../components/surveys/Surveys';
import { 
  profile,
  surveys,
  surveysLoading,
  surveysCreating,
  surveysUpdating,
  surveysDeleting,
  surveysToggling,
  surveysErrorMessage,
  surveyResponses,
  surveyResponsesLoading,
  surveyResponsesErrorMessage,
  sucursal_id,
} from 'core/selectors';
import {
  getSurveys,
  createSurvey,
  updateSurvey,
  deleteSurvey,
  getSurveyResponses,
} from 'core/slices/surveys';

export default connect(
  state => ({
    profile: profile(state),
    surveys: surveys(state),
    surveysLoading: surveysLoading(state),
    creatingSurvey: surveysCreating(state),
    updatingSurvey: surveysUpdating(state),
    deletingSurvey: surveysDeleting(state),
    togglingSurvey: surveysToggling(state),
    surveysErrorMessage: surveysErrorMessage(state),
    responses: surveyResponses(state),
    responsesLoading: surveyResponsesLoading(state),
    responsesErrorMessage: surveyResponsesErrorMessage(state),
    sucursal_id: sucursal_id(state),
  }),
  {
    getSurveys,
    createSurvey,
    updateSurvey,
    deleteSurvey,
    getSurveyResponses,
  },
)(Surveys);
